// yarn add qrcanvas -S
// import { qrcanvas } from 'qrcanvas/lib/qrcanvas'
import { qrcanvas } from './qrcanvas'
//import Encodes from './Encodes'

export default class VaryQR {
  constructor(size = 12, logo = '', option = {}) {
    this.logo = logo
    this.logoImage = null
    this.canvas = null
    this.text = null
    this.interval = 1000
    this.colorFore = '#000000'
    // this.colorOut = '#000000'
    // this.colorIn = '#621'
    this.correctLevel = 'H'
    this.cellSize = size || 10
    this.colors = ['red', 'green', 'blue', 'yellow', 'black'] // 可以取值亮色调的，已获得更好的识别效果
    this.colorsMap = { yellow: '#DDD000', green: '#10FF10' }
    this.dots = ['red', 'green', 'blue']
    this.callback = option.callback || null
    this.option = Object.assign({}, option)
    this.ttl = 120
    //this.encodes = Encodes(this.colors)
    Object.assign(this, option)
  }

  _rotateArray(arr, k = 1) {
    // const _k = k || Math.random() * (4 - 1) + 1
    arr.splice(0, 0, ...arr.splice(arr.length - k))
  }

  /**
   * build qr code
   * @param {string} text
   * @returns this
   */
  async createQRCode(text) {
    this.text = text || this.text
    if (!this.text) {
      return
    }

    if (this.logo && !this.logoImage) {
      this.logoImage = await this._getImage(this.logo)
    }

    // this.dots = ['black', 'black', 'black']
    this.dots = this.dots.map((c) => this.colorsMap[c] || c)

    const option = {
      data: this.text,
      cellSize: this.cellSize,
      correctLevel: this.correctLevel,
      foreground: [
        // foreground color
        { style: this.colorFore },
        // outer squares of the positioner
        { row: -7, rows: 7, col: 0, cols: 7, style: this.dots[0] },
        { row: 0, rows: 7, col: 0, cols: 7, style: this.dots[1] },
        { row: 0, rows: 7, col: -7, cols: 7, style: this.dots[2] },
        // inner squares of the positioner
        { row: -5, rows: 3, col: 2, cols: 3, style: this.dots[0] },
        { row: 2, rows: 3, col: 2, cols: 3, style: this.dots[1] },
        { row: 2, rows: 3, col: -5, cols: 3, style: this.dots[2] },
      ],
    }

    if (this.logoImage) {
      option.logo = this.logoImage
    }

    this.canvas = qrcanvas.qrcanvas(option)
    return this
  }

  /**
   * get logo image
   * @param {string} src
   * @returns
   */
  async _getImage(src) {
    return await new Promise((resolve) => {
      const image = new Image()
      image.src = src
      image.onload = () => {
        resolve(image)
      }
    })
  }

  async toDataURL(type = 'image/png') {
    return await this.canvas.toDataURL(type)
  }

  /**
   * start qr code bulder by interval
   * @param {string} text
   */
  async start(text) {
    this.text = text

    this.timer = setInterval(async (_) => {
      // 移位循环法
      // this._rotateArray(this.dots, 1)

      // 顺序码表规则
      this.ttl--
      if (this.ttl <= 0) {
        this.destroy()
      }
      this.dots = this.encodes[this.ttl]

      await this.createQRCode()
      if (this.callback) {
        this.callback(this.canvas, this)
      }
    }, this.interval)

    return this
  }

  stop() {
    this.text = null
  }

  /**
   * release object
   */
  destroy() {
    this.stop()
    clearInterval(this.timer)
  }
}
